import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaLinkedin, FaPinterest } from 'react-icons/fa';
import logo from '../assets/logo/CIG_2601_Logo-01.png';
import FullMinimalSection from './FullMinimalSection';
import image2 from "../assets/lingotti/0017 - Still life Care is gold-Modifica.webp";
import 'aos/dist/aos.css';

function Footer({ banner }) {
  const lineRef = useRef(null);

  const [isFaqMenuOpen, setIsFaqMenuOpen] = useState(false);
  const faqMenuRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5
    };

    const lineElement = lineRef.current;
    const elements = document.querySelectorAll('.animation-footer-text');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          lineElement.classList.add('animated-line');
          elements.forEach(element => {
            element.classList.remove('opacity-0');
            element.classList.add('opacity-1');
          });
        } else {
          lineElement.classList.remove('animated-line');
          elements.forEach(element => {
            element.classList.remove('opacity-1');
            element.classList.add('opacity-0');
          });
        }
      });
    }, options);

    if (lineElement) observer.observe(lineElement);

    return () => {
      if (lineElement) {
        observer.unobserve(lineElement);
      }
    };
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (faqMenuRef.current && !faqMenuRef.current.contains(event.target)) {
        setIsFaqMenuOpen(false);
      }
    }

    function handleEscape(event) {
      if (event.key === 'Escape') {
        setIsFaqMenuOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  return (
    <>
      {banner && (
        <FullMinimalSection
          headerImage={image2}
          logoTransp=''
          title="Non esitare. Chiedi e ti risponderemo."
          description={`Compila il form in 10 secondi e un nostro esperto ti contatterà per fornirti tutte le informazioni di cui hai bisogno, senza impegno e gratuitamente.`}
          href='/contatti/'
          logoPosition='left-[-40vh] top-[-30vh] w-[110vh]'
          buttonText='Contattaci'
          darkButton={true}
          buttonClass='lg:w-1/2'
          buttonClass2='hidden'
        />
      )}

      <footer className="relative lg:w-full bg-black text-white lg:py-20 py-10 px-5">
        <img src={logo} alt="logo careisgold" className="lg:absolute me-auto mb-10 lg:w-1/6 sm:w-1/3 w-1/2" />

        <div className="w-full flex justify-start lg:justify-center items-center z-20">
          <div className={`text-start 2xl:w-1/2 ms-auto xl:ms-0`}>
            <h2 className={`lg:text-2xl text-lg font-semibold uppercase mb-2`}>Careisgold SpA</h2>
            <p className={`text-sm lg:text-lg`}>Via Monte Baldo 14/D, Villafranca di Verona (VR)</p>
            <p className={`text-sm lg:text-lg`}>C.F./P.Iva 04598560235 - REA VR-433912</p>
            <p className={`text-sm lg:text-lg`}>CAP. SOCIALE € 2.000.000,00 i.v.</p>
            <p className={`text-sm lg:text-lg`}>careisgoldspa@pec.careisgold.it</p>
            <p className={`text-sm lg:text-lg`}>Tel. 045 2457421</p>
            <p className={`text-sm lg:text-lg mb-10`}>Operatore Professionale Oro - iscritto nel registro OAM n. OPO6</p>

            <hr ref={lineRef} className="border-b border-gray-300 my-4" />

            <div className='space-y-6'>
              <ul className="flex justify-start gap-4" aria-label="Link social Careisgold">
                <li>
                  <a
                    aria-label="Visita la pagina Facebook di Careisgold"
                    href="https://www.facebook.com/careisgoldspa/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm mt-3 lg:m-0 hover:text-gray-400 opacity-0 animation-footer-text"
                    style={{ transition: "opacity 1.5s ease-in" }}
                  >
                    <FaFacebook />
                  </a>
                </li>

                <li>
                  <a
                    aria-label="Visita la pagina Instagram di Careisgold"
                    href="https://www.instagram.com/careisgoldspa/?igshid=15rizhw3869f2"
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm mt-3 lg:m-0 hover:text-gray-400 opacity-0 animation-footer-text"
                    style={{ transition: "opacity 2s ease-in" }}
                  >
                    <FaInstagram />
                  </a>
                </li>

                <li>
                  <a
                    aria-label="Visita la pagina Linkedin di Careisgold"
                    href="https://www.linkedin.com/company/careisgold-spa"
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm mt-3 lg:m-0 hover:text-gray-400 opacity-0 animation-footer-text"
                    style={{ transition: "opacity 2.5s ease-in" }}
                  >
                    <FaLinkedin />
                  </a>
                </li>

                <li>
                  <a
                    aria-label="Visita la pagina Pinterest di Careisgold"
                    href="https://www.pinterest.com/Careisgold/?actingBusinessId=1007469516550293342"
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm mt-3 lg:m-0 hover:text-gray-400 opacity-0 animation-footer-text"
                    style={{ transition: "opacity 2.5s ease-in" }}
                  >
                    <FaPinterest />
                  </a>
                </li>
              </ul>

              <ul className="flex justify-start gap-4 flex-wrap" aria-label="Link utili">
                <li>
                  <Link
                    to="/azienda/"
                    className="text-sm mt-3 lg:m-0 hover:text-gray-400 opacity-0 animation-footer-text"
                    style={{ transition: "opacity 0.5s ease-in" }}
                  >
                    Azienda
                  </Link>
                </li>

                <li>
                  <Link
                    to="/contatti/"
                    className="text-sm mt-3 lg:m-0 hover:text-gray-400 opacity-0 animation-footer-text"
                    style={{ transition: "opacity 1s ease-in" }}
                  >
                    Contatti
                  </Link>
                </li>

                <li>
                  <a
                    href="https://www.iubenda.com/privacy-policy/95086304"
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm mt-3 lg:m-0 hover:text-gray-400 opacity-0 animation-footer-text"
                    style={{ transition: "opacity 2.5s ease-in" }}
                  >
                    Privacy Policy
                  </a>
                </li>

                <li>
                  <a
                    href="https://www.iubenda.com/privacy-policy/95086304/cookie-policy"
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm mt-3 lg:m-0 hover:text-gray-400 opacity-0 animation-footer-text"
                    style={{ transition: "opacity 3.5s ease-in" }}
                  >
                    Terms of Service
                  </a>
                </li>

                <li>
                  <Link
                    to="/info/whistleblowing/"
                    className="text-sm mt-3 lg:m-0 hover:text-gray-400 opacity-0 animation-footer-text"
                    style={{ transition: "opacity 4s ease-in" }}
                  >
                    Whistleblowing
                  </Link>
                </li>

                <li>
                  <Link
                    to="/info/reclami/"
                    className="text-sm mt-3 lg:m-0 hover:text-gray-400 opacity-0 animation-footer-text"
                    style={{ transition: "opacity 4s ease-in" }}
                  >
                    Reclami
                  </Link>
                </li>

                <li>
                  <a
                    href="/pdf/dichiarazione-accessibilita.pdf"
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm mt-3 lg:m-0 hover:text-gray-400 opacity-0 animation-footer-text"
                    style={{ transition: "opacity 4s ease-in" }}
                  >
                    Accessibilità
                  </a>
                </li>

                <li
                  ref={faqMenuRef}
                  className="relative opacity-0 animation-footer-text"
                  style={{ transition: "opacity 4s ease-in" }}
                >
                  <button
                    type="button"
                    onClick={() => setIsFaqMenuOpen(prev => !prev)}
                    aria-expanded={isFaqMenuOpen}
                    aria-haspopup="true"
                    className="text-sm mt-0.5 hover:text-gray-400 flex items-center gap-2"
                  >
                    Fare Chiarezza
                    <span className={`text-sm transition-transform duration-200 ${isFaqMenuOpen ? 'rotate-180' : ''}`}>
                      ▼
                    </span>
                  </button>

                  {isFaqMenuOpen && (
                    <div className="absolute left-0 bottom-full mb-2 min-w-[240px] bg-black text-white border border-white rounded-md shadow-lg overflow-hidden z-50">
                      <Link
                        to="/fare-chiarezza/"
                        className="block px-4 py-2 text-sm hover:bg-gray-100 hover:text-black"
                        onClick={() => setIsFaqMenuOpen(false)}
                      >
                        Careisgold è affidabile?
                      </Link>

                      <Link
                        to="/domande-frequenti/"
                        className="block px-4 py-2 text-sm hover:bg-gray-100 hover:text-black"
                        onClick={() => setIsFaqMenuOpen(false)}
                      >
                        Domande Frequenti
                      </Link>

                      <Link
                        to="/careisgold-recensioni-negative-cosa-dicono-e-cosa-signficano/"
                        className="block px-4 py-2 text-sm hover:bg-gray-100 hover:text-black"
                        onClick={() => setIsFaqMenuOpen(false)}
                      >
                        Recensioni negative
                      </Link>
                    </div>
                  )}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;